import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Pie, Column } from "@ant-design/plots";
import _ from "lodash";

import {
  getGroupedByActivityData,
  getGroupedByActivityStatus,
  getGroupedByCallActivityData,
  getGroupedByMeetingActivityData,
  getGroupedByEmailActivityData,
} from "../../actionCreator/dashboardActionCreator";
import { getUserInfo } from "../../utils/utils";

const ActivitiesReport = () => {
  const dispatch = useDispatch();
  const userAccountInfo = useSelector(
    (state) => state.CommonReducer.accountInfo
  );
  const groupedActivityData = useSelector(
    (state) => state.DashboardReducer.groupedActivityData
  );
  const groupedActivityStatusData = useSelector(
    (state) => state.DashboardReducer.groupedActivityStatusData
  );

  const groupedActivityCallData = useSelector(
    (state) => state.DashboardReducer.groupedActivityCallData
  );
  const groupedActivityMeetingData = useSelector(
    (state) => state.DashboardReducer.groupedActivityMeetingData
  );
  const groupedActivityEmailData = useSelector(
    (state) => state.DashboardReducer.groupedActivityEmailData
  );

  useEffect(() => {
    if (Object.keys(getUserInfo()).length) {
      dispatch(getGroupedByActivityData());
      dispatch(getGroupedByActivityStatus());
      dispatch(getGroupedByCallActivityData());
      dispatch(getGroupedByMeetingActivityData());
      dispatch(getGroupedByEmailActivityData());
    }
  }, [userAccountInfo]);
  let activityByStatusdata = [];
  let activityByStatusdataOrg = [];
  if (groupedActivityStatusData?.dashboardDTOS?.length > 0) {
    groupedActivityStatusData?.dashboardDTOS?.forEach((record) => {
      record.countSum = record?.countSum ? parseInt(record.countSum) : 0;
      record.typeValue =
        record?.typeValue == "null" || record?.typeValue == ""
          ? "Others"
          : record?.typeValue;
      record.order = record?.typeValue == "Others" ? "b" : "a";
      activityByStatusdataOrg.push(record);
    });
    activityByStatusdata = _.orderBy(activityByStatusdataOrg, "order", "asc");
  }
  let leadByStatusdata = [];
  let leadByStatusdataOrg = [];
  let totalLeadByStatusCnt = 0;
  if (groupedActivityData?.dashboardDTOS?.length > 0) {
    groupedActivityData?.dashboardDTOS?.forEach((record) => {
      record.statusId = record?.statusId ? parseInt(record.statusId) : 0;
      record.typeValue =
        record?.typeValue == "null" || record?.typeValue == ""
          ? "Others"
          : record?.typeValue;
      record.order = record?.typeValue == "Others" ? "b" : "a";
      totalLeadByStatusCnt += record.statusId;
      leadByStatusdataOrg.push(record);
    });
    leadByStatusdata = _.orderBy(leadByStatusdataOrg, "order", "asc");
  }
  let groupedActivityCallDataArr = [];
  if (groupedActivityCallData?.dashboardDTOS?.length > 0) {
    groupedActivityCallDataArr = groupedActivityCallData.dashboardDTOS;
  }
  let groupedActivityMeetingDataArr = [];
  if (groupedActivityMeetingData?.dashboardDTOS?.length > 0) {
    groupedActivityMeetingDataArr = groupedActivityMeetingData.dashboardDTOS;
  }
  let groupedActivityEmailDataArr = [];
  if (groupedActivityEmailData?.dashboardDTOS?.length > 0) {
    groupedActivityEmailDataArr = groupedActivityEmailData.dashboardDTOS;
  }

  const typeValueBlock = [
    "meeting",
    "call",
    "email",
    "chat",
    "whatsapp",
    "demo",
  ];

  const activityByStatusChart = {
    forceFit: true,
    data: activityByStatusdata,
    angleField: "countSum",
    colorField: "typeValue",
    radius: 0.8,
    label: {
      type: "inner",
      visible: true,
      content: "{value}",
      autoRotate: false,
     
      style: {
        textAlign: "center",
        fontSize: 14,
      },
    },
    statistic: {
      title: false,
      content: {
        style: {
          whiteSpace: "pre-wrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        content: "Total\n" + totalLeadByStatusCnt,
      },
    },
  };

  const leadByStatus = {
    data: leadByStatusdata,
    xField: "typeValue",
    yField: "opportunitSum",
    seriesField: "typeValue",
    isPercent: false,
    isStack: false,
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
  };

  const chartForCall = {
    data: groupedActivityCallDataArr,
    xField: "countSum",
    yField: "statusId",
    seriesField: "statusId",
    legend: {
      visible: true,
    },
    meta: {
      statusId: {
        alias: "Name",
      },
      countSum: {
        alias: "Count",
      },
    },
    minBarWidth: 20,
    maxBarWidth: 20,
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
  };

  const chartForMeeting = {
    data: groupedActivityMeetingDataArr,
    xField: "countSum",
    yField: "statusId",
    seriesField: "statusId",
    legend: {
      visible: true,
    },
    meta: {
      statusId: {
        alias: "Name",
      },
      countSum: {
        alias: "Count",
      },
    },
    minBarWidth: 20,
    maxBarWidth: 20,
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
  };
  const chartForEmail = {
    data: groupedActivityEmailDataArr,
    xField: "countSum",
    yField: "statusId",
    seriesField: "statusId",
    legend: {
      visible: true,
    },
    meta: {
      statusId: {
        alias: "Name",
      },
      countSum: {
        alias: "Count",
      },
    },
    minBarWidth: 20,
    maxBarWidth: 20,
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
  };

  let otherValues = 0;
  let cl;
  return (
    <>
      <div className="row mx-0 mt-4 pt-4">
        {groupedActivityData?.dashboardDTOS?.map((record) => {
          const { typeValue, countSum } = record || {};
          if (!typeValueBlock.includes(typeValue?.toLowerCase())) {
            otherValues += record.countSum && parseInt(record.countSum);
          }
          if (typeValue?.toLowerCase() == "call") {
            cl = "las la-phone-volume fa-2x text-gray-300";
          } else if (typeValue?.toLowerCase() == "email") {
            cl = "las la-envelope fa-2x text-gray-300";
          } else if (typeValue?.toLowerCase() == "meeting") {
            cl = "las la-handshake fa-2x text-gray-300";
          } else if (typeValue?.toLowerCase() == "demo") {
            cl = "las la-laptop fa-2x text-gray-300";
          } else {
            cl = "las la-comment fa-2x text-gray-300";
          }
          return (
            typeValueBlock.includes(typeValue?.toLowerCase()) && (
              <div key={typeValue} className="col-xl-3 col-md-6 mb-4">
                <div className="card border-left-primary shadow h-100 py-2">
                  <div className="card-body">
                    <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                      {typeValue}
                    </div>
                    <div className="row mx-0 no-gutters align-items-center">
                      <div className="col mr-2">
                        <div className="h5 mb-0 font-weight-bold text-gray-800">
                          {countSum}
                        </div>
                      </div>
                      <div className="col-auto">
                        <i className={cl}></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          );
        })}

        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-primary shadow h-100 py-2">
            <div className="card-body">
              <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                Others
              </div>
              <div className="row mx-0 no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="h5 mb-0 font-weight-bold text-gray-800">
                    {otherValues}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="las la-hand-pointer fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mx-0">
        <div className="col-xl-4 col-lg-5">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 className="m-0 font-weight-bold text-gray-800 text-uppercase">
                Activity By Type
              </h6>
            </div>

            <div className="card-body">
              <div className="chart-pie pt-4 pb-2">
                <div className="chartjs-size-monitor">
                  <div className="chartjs-size-monitor-expand">
                    <div className="card-body">
                      <div className="chart-area">
                        <Column {...leadByStatus} style={{ height: 220 }} />
                      </div>
                    </div>
                  </div>
                  <div className="chartjs-size-monitor-shrink">
                    <div className=""></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-lg-5">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 className="m-0 font-weight-bold text-uppercase text-gray-800">
                Activity By Status
              </h6>
            </div>
            <div className="card-body">
              <div className="chart-pie pt-4 pb-2">
                <div className="chartjs-size-monitor">
                  <div className="chartjs-size-monitor-expand">
                    <div className="" style={{ height: 220 }}>
                      {<Pie {...activityByStatusChart} />}
                    </div>
                  </div>
                  <div className="chartjs-size-monitor-shrink">
                    <div className=""></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-lg-5">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 className="m-0 font-weight-bold text-uppercase text-gray-800">
                Most Meeting Held (Top 5)
              </h6>
            </div>
            <div className="card-body">
              <div className="chart-pie pt-4 pb-2">
                <div className="chartjs-size-monitor">
                  <div className="chartjs-size-monitor-expand">
                    <div className="" style={{ height: 220 }}>
                      <Column {...chartForMeeting} />
                    </div>
                  </div>
                  <div className="chartjs-size-monitor-shrink">
                    <div className=""></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mx-0">
        <div className="col-xl-4 col-lg-5">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 className="m-0 font-weight-bold text-gray-800 text-uppercase">
                Most Email Sent (Top 5)
              </h6>
            </div>
            <div className="card-body">
              <div className="chart-pie pt-4 pb-2">
                <div className="chartjs-size-monitor">
                  <div className="chartjs-size-monitor-expand">
                    <div className="" style={{ height: 220 }}>
                      <Column {...chartForEmail} />
                    </div>
                  </div>
                  <div className="chartjs-size-monitor-shrink">
                    <div className=""></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-lg-5">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 className="m-0 font-weight-bold text-gray-800 text-uppercase">
                Most Call Made (Top 5)
              </h6>
            </div>
            <div className="card-body">
              <div className="chart-pie pt-4 pb-2">
                <div className="chartjs-size-monitor">
                  <div className="chartjs-size-monitor-expand">
                    <div className="" style={{ height: 220 }}>
                      <Column {...chartForCall} />
                    </div>
                  </div>
                  <div className="chartjs-size-monitor-shrink">
                    <div className=""></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActivitiesReport;
